module.exports = __webpack_public_path__ + "media/images/landkit/buttons/button-play-8dc1e7c837d1e0e85da7cb40c8de1424.png";